import { getRouteApi } from "@tanstack/react-router"
// import { Input } from "@workspace/web-ui/components/input"


const COLORS = {
    TEXT_PRIMARY: '#2D2F35',
    TEXT_SECONDARY: '#667085',
} as const



const MedicationCard = ({ title, description }: { title: string, description: string }) => (
    <div className="flex gap-4 w-full">
        <h2 style={{ color: COLORS.TEXT_PRIMARY }} className="text-sm font-normal text-[#202020CC] w-20 shrink-0">{title}</h2>
        <span style={{ color: COLORS.TEXT_PRIMARY }} className="text-sm font-semibold text-[#202020CC] flex-1">{description || "--"}</span>
    </div>
)


interface RefillCardProps {
    medicationName: string
    medicationDosage: string
    medicationQuantity: string
    medicationVitamin: string
}


export const RefillCard = ({ medicationName, medicationDosage, medicationQuantity, medicationVitamin }: RefillCardProps) => {
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
    const { program } = routeApi.useParams();
    return (
        <div className="flex flex-col gap-3 w-full p-4 rounded-[8px] bg-white border border-[#E6E6E6]">
            <h2 className="text-base font-medium">Requested medication</h2>
            {/* PATIENT LOG */}
            <div className="grid grid-cols-1 gap-4 w-full ">
                <MedicationCard title="Medication" description={medicationName} />
                <MedicationCard title="Dosage" description={medicationDosage} />
                {program !== 'weight-loss' && (
                    <MedicationCard title="Refills" description={medicationQuantity} />
                )}
                {program === 'weight-loss' && (
                    <MedicationCard 
                        title="Vitamin" 
                        description={medicationName.toLowerCase().includes('zepbound') ? '--' : medicationVitamin} 
                    />
                )}
            </div>
        </div>
    )
}

